import { useContext } from "react";
import { CachedStateProvider, ICachedStateProvider, IControlledMutator } from "sonobello.utilities.react";

import { SessionContext } from "../../../Context/SessionContext";

/** An extension of the cached state provider which overrides the default get/write behaviors with the correct
 * callbacks for the current session.
 */
function SessionCacheStateProvider<TValueType, TComponent extends IControlledMutator<TValueType | null>>(
  props: Omit<ICachedStateProvider<TValueType, TComponent>, "writeCache" | "getCache">
): React.FC<Omit<TComponent, "value" | "onChange">> {
  return componentProps => {
    const {
      helpers: { loadFromLocal, saveToLocal }
    } = useContext(SessionContext);
    return CachedStateProvider({
      ...componentProps,
      ...props,
      writeCache: (key, obj) => saveToLocal(obj, key),
      getCache: key => loadFromLocal(key) || null
    });
  };
}

export default SessionCacheStateProvider;
